import store from '@/store';

export function restoreSession() {
  return store.dispatch('user/restoreSession');
}
